import * as React from "react";
import { Intent, Spinner } from "@blueprintjs/core";
import "./PlaceholderText.css";
import { isLoading, loading, Loading } from "../../Loading";
import { Document, Page } from "react-pdf";
import { delay } from "../../system/delay";

interface PlaceholderFormattedTextProps {
    questionText: string;
}

export class PlaceholderFormattedText extends React.Component<PlaceholderFormattedTextProps> {
    constructor(props: PlaceholderFormattedTextProps) {
        super(props);
    }

    render() {
        return (
            <div className={"regular"} >
               <span dangerouslySetInnerHTML={{ __html: this.props.questionText }}/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/placeholders/PlaceholderFormattedText.tsx